import { ScreenLoader } from '@/components'
import { UserRedirectScreen } from '@/screens/UserRedirectScreen'

// eslint-disable-next-line react/display-name
export default () => (
  <ScreenLoader
    // ensure we always have the latest data, so we route appropriately
    fetchPolicy='network-only'
    queryName='UserRedirectScreenQuery'
    ScreenComponent={UserRedirectScreen}
  />
)
